import ServiceTemplate from '@/components/ServiceTemplate';

export default function ImmigrationLaw() {
  const data = {
    title: 'Business Immigration Law Services',
    subtitle: 'Immigration support for businesses hiring foreign workers and international talent.',
    overviewTitle: 'Immigration Services for Businesses',
    overviewImage: 'https://images.unsplash.com/photo-1763718528755-4bca23f82ac3',
    description: [
      'Businesses hiring foreign nationals must navigate complex immigration laws including work visas, permanent residency sponsorship, and compliance requirements. Proper handling is essential to avoid penalties and maintain legal status.',
      'Our business immigration service helps companies hire international talent through H-1B, L-1, O-1, and other work visas, as well as permanent residency sponsorship programs.',
      'We guide businesses through the immigration process, ensuring compliance while securing authorization for valuable employees.'
    ],
    benefits: [
      { title: 'Work Visa Support', description: 'H-1B, L-1, O-1, and other employment-based visas.' },
      { title: 'Green Card Sponsorship', description: 'Permanent residency for key employees.' },
      { title: 'Compliance Guidance', description: 'Navigate employer compliance requirements.' },
      { title: 'Strategic Planning', description: 'Immigration strategy for workforce needs.' },
      { title: 'Document Preparation', description: 'Complete immigration applications and petitions.' },
      { title: 'Government Liaison', description: 'Communication with USCIS and other agencies.' }
    ],
    process: [
      { title: 'Investigation & Analysis', description: 'Comprehensive review and analysis of all relevant legal, financial, and operational factors.' },
      { title: 'Documentation & Recommendations', description: 'Detailed documentation of findings with strategic recommendations for action.' },
      { title: 'Implementation & Support', description: 'Ongoing support for implementation of recommendations and resolution of issues.' }
    ],
    pricing: [
      {
        name: 'Consultation',
        description: 'Initial assessment',
        price: '$299',
        period: 'Per session',
        features: [
          '90-minute consultation',
          'Situation analysis',
          'Strategy recommendations',
          'Action plan',
          'Written summary',
          'Follow-up email support'
        ]
      },
      {
        name: 'Retainer',
        description: 'Ongoing advisory',
        price: '$1,499',
        period: 'Per month',
        featured: true,
        features: [
          'Monthly strategy sessions',
          'Unlimited email support',
          'Priority phone access',
          'Document review',
          'Compliance monitoring',
          'Quarterly reporting',
          'Dedicated attorney'
        ]
      },
      {
        name: 'Project-Based',
        description: 'Custom engagement',
        price: 'Custom',
        period: 'Based on scope',
        features: [
          'Scope-based pricing',
          'Dedicated team',
          'Project management',
          'Milestone deliverables',
          'All work product included',
          'Comprehensive reporting',
          'Executive support'
        ]
      }
    ],
    faqs: [
      { question: 'What is an H-1B visa?', answer: 'H-1B visas allow U.S. employers to hire foreign workers in specialty occupations requiring bachelor\'s degree or higher.' },
      { question: 'What is the H-1B cap?', answer: 'Annual cap of 65,000 H-1B visas (plus 20,000 for advanced degree holders). Cap-subject positions require lottery registration in March.' },
      { question: 'What is an L-1 visa?', answer: 'L-1 visas allow international companies to transfer managers, executives, or specialized knowledge workers to U.S. offices.' },
      { question: 'What is an O-1 visa?', answer: 'O-1 visas are for individuals with extraordinary ability in sciences, arts, education, business, or athletics.' },
      { question: 'How do I sponsor permanent residency?', answer: 'Through employment-based green cards requiring labor certification (PERM) for most categories, demonstrating no qualified U.S. workers available.' },
      { question: 'What is prevailing wage?', answer: 'Minimum wage that must be paid to H-1B and green card sponsored employees, determined by Department of Labor based on job and location.' },
      { question: 'What are I-9 requirements?', answer: 'Employers must verify employment authorization for all employees using Form I-9, maintaining records and avoiding discrimination.' },
      { question: 'Can employees work while waiting?', answer: 'H-1B and certain other petitions allow work authorization upon filing. Green card applicants can apply for work permits (EAD) after filing.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
